import { SelectorOption } from "../../../components/Redux/BasicSelector";

export const BearerTokenFormatOptions: SelectorOption[] = [
  { label: "Default", id: "default" },
  { label: "IDP Access Token", id: "idp_access_token" },
  { label: "IDP Identity Token", id: "idp_identity_token" },
];
